import React, { useState, useEffect } from "react";
import { useWindowSize } from "@react-hook/window-size";
import classNames from "classnames";

export const GameFrame = ({ src, width, height, iframeRef, lights }) => {
  const [liveDimensions, setLiveDimensions] = useState({ width, height });
  const [paddingRatio, setPaddingRatio] = useState((height / width) * 100);
  const [windowWidth, windowHeight] = useWindowSize();

  const handleResize = () => {
    // game height should never be more than one window screen with buffer
    // users should beable to scroll the whole game into frame
    let constrainedHeight = height;
    if (height > windowHeight) {
      constrainedHeight = parseInt(windowHeight - 50, 10);
    }

    // adjust width by the constraint ratio
    const constrainedWidth = Math.floor((height / constrainedHeight) * width);

    setLiveDimensions({
      width: constrainedWidth,
      height: constrainedHeight
    });

    setPaddingRatio((constrainedHeight / constrainedWidth) * 100);
  };

  const handleLoad = () => {
    iframeRef.current.contentWindow.focus();
    handleResize();
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="responsive bg-block-light mt-3">
      <div
        className="relative w-full m-2 mx-auto"
        style={{
          paddingTop: lights && windowWidth < 1000 ? `${paddingRatio}%` : null,
          width: `${liveDimensions.width}px`,
          height: `${liveDimensions.height}px`
        }}
      >
        <iframe
          ref={iframeRef}
          width={liveDimensions.width}
          height={liveDimensions.height}
          className={classNames(`z-40`, {
            "absolute left-0 top-0": lights,
            "w-full h-full": windowWidth < 1000,
            "mx-auto": windowWidth > 1000,
          })}
          src={src}
          frameBorder="0"
          scrolling="no"
          allowFullScreen={true}
          onLoad={handleLoad}
        />
      </div>
    </div>
  );
};
